import { useState, useEffect, useCallback, useRef } from 'react'
import { authenticatedFetchJson } from '../services/api/apiClient'
import { apiEndpoints } from '../consts'
import logger from '../utils/logger'

const usePendingReviewData = () => {
  const [cycles, setCycles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const mountedRef = useRef(true)

  const fetchData = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await authenticatedFetchJson(apiEndpoints.billingPendingReview)
      if (mountedRef.current) setCycles(res?.data || [])
    } catch (err) {
      logger.error('Failed to fetch pending review data:', err)
      if (mountedRef.current) setError(err.message || 'Failed to load pending review data')
    } finally {
      if (mountedRef.current) setLoading(false)
    }
  }, [])

  useEffect(() => {
    mountedRef.current = true
    fetchData()
    return () => { mountedRef.current = false }
  }, [fetchData])

  return { cycles, loading, error, refetch: fetchData }
}

export default usePendingReviewData
